export enum CallLogStatus {
  AllIncoming = 'Incoming: All',
  AllOutgoing = 'Outgoing All',
  ConnectedIncoming = 'Incoming call: connected',
  MissedIncoming = 'Incoming call: missed',
  ConnectedOutoing = 'Outgoing call: connected',
  MissedOutgoing = 'Outgoing call: missed',
}
